import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./OrderDetailsActionNotifications.module.scss";
import Grid from "@material-ui/core/Grid";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import UpperCaseText from "../../../../utils/UpperCaseText";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { NULL_OR_UNDEFINED } from "../../../../utils/EmpUtil";
import {
  CASH,
  FINANCE,
  LEASE,
  OFFLINEFINANCE,
  OFFLINELEASE,
  OFFLINEPRIVATELEASE,
  PRIVATE_LEASE,
  FINANCE_OPTIONS,
} from "../../../../common/Constants";
import LowerCaseText from "../../../../utils/LowerCaseText";
import FormatDocReasonText from "../../../../utils/FormatDocReasonText";

const financeFailedStatuses = [
  "DENIED",
  "DENIED_SUPPRESSED",
  "FINANCE_SUPPRESSED",
  "FINANCE_EID_CHECKED_FAIL",
  "FINANCE_REFERRED",
  "ERROR",
];

const OrderDetailsNotification = (props) => {
  return (
    <div>
      {props.displayNotification && (
        <Grid
          container
          className={
            props.warningColor
              ? `${styles.actionNotificationBox} ${styles.warningBoxColor}`
              : `${styles.actionNotificationBox} ${styles.whiteBoxColor}`
          }
        >
          <Grid item xs={1} className={styles.actionNotificationText}>
            {props.warningColor ? (
              <div className={styles.actionWarningIcon} />
            ) : (
              <InfoOutlinedIcon />
            )}
          </Grid>
          <Grid item xs={2} className={styles.actionNotificationText}>
            <div>{props.showActionRequired && props.showActionRequired}</div>
          </Grid>
          <Grid item xs={6} className={styles.actionNotificationMsg}>
            <div>{props.showMessage && props.showMessage}</div>
          </Grid>
          <Grid item xs={2} className={styles.actionNotificationText}>
            <div>{props.showPriority && props.showPriority}</div>
          </Grid>
          <Grid item xs={1}>
            <HasPermissionTo
              perform={["deleteNotification"]}
              permissions={props.user.permissions.rolePermissions}
              condition={props.showCloseIcon}
              render={() => {
                return (
                  <div className={styles.closeDiv}>
                    <div
                      className={styles.closeIcon}
                      data-testid="closeNotification"
                      onClick={() => props.handleClose()}
                    />
                  </div>
                );
              }}
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

class OrderDetailsActionNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeInNotification: true,
      optOfflineNotification: true,
      paymentNotification: true,
      inventoryLessNotification: true,
      closedNotifications: [],
    };
    this.isOrderCancelled = this.props.isOrderCancelled(
      UpperCaseText(this.props.customerReservation.status)
    );
    this.isReservation = this.props.isReservation(
      this.props.customerReservation.orderType
    );
  }

  handleTradeInNotification = () => {
    this.setState({ tradeInNotification: false });
  };
  handleOptOfflineNotification = () => {
    this.setState({ optOfflineNotification: false });
  };
  handlePaymentNotification = () => {
    this.setState({ paymentNotification: false });
  };
  handleOrderUpdateNotification = (index) => {
    const copy = this.state.closedNotifications;
    copy.push(index);
    this.setState({ closedNotifications: copy });
  };

  getLatestFinanceStatus = () => {
    const customerReservation = this.props.customerReservation;
    if (
      customerReservation &&
      customerReservation.paymentDescription &&
      customerReservation.paymentDescription.length > 0
    ) {
      const statusObject =
        customerReservation.paymentDescription[
          customerReservation.paymentDescription.length - 1
        ];
      return statusObject.status;
    } else {
      return null;
    }
  };

  getOrderUpdateNotificationMessage = (notification) => {
    const documentName = this.props.t(
      "FinanceLeaseNotifications." + notification.documentName
    );

    let message =
      documentName + " - " + FormatDocReasonText(notification, this.props);

    if (
      notification.documentSupportReason !== "" &&
      !NULL_OR_UNDEFINED(notification.documentSupportReason)
    ) {
      message = message + " - " + notification.documentSupportReason;
    }

    return message;
  };

  isCashNotAccepted = (customerReservation) => {
    if (LowerCaseText(customerReservation.paymentType) === CASH) {
      if (
        customerReservation.acceptTheOrderData &&
        customerReservation.acceptTheOrderData.dealerAcceptedDate &&
        customerReservation.acceptTheOrderData.dealerActionUserId
      )
        return false;
      return true;
    }
    return false;
  };

  isFinanceNotAccepted = (customerReservation) => {
    if (
      LowerCaseText(customerReservation.paymentType) === FINANCE ||
      LowerCaseText(customerReservation.paymentType) === OFFLINEFINANCE
    )
      return !this.checkIsPaymentApproved(
        customerReservation.paymentDescription
      );
    return false;
  };

  isLeaseNotAccepted = (customerReservation) => {
    if (
      LowerCaseText(customerReservation.paymentType) === LEASE ||
      LowerCaseText(customerReservation.paymentType) === OFFLINELEASE ||
      LowerCaseText(customerReservation.paymentType) === PRIVATE_LEASE ||
      LowerCaseText(customerReservation.paymentType) === OFFLINEPRIVATELEASE
    )
      return !this.checkIsPaymentApproved(
        customerReservation.paymentDescription
      );
    return false;
  };

  checkIsPaymentApproved = (paymentDesc) => {
    let isApproved = false;
    paymentDesc &&
      paymentDesc.length > 0 &&
      paymentDesc.forEach((item, index) => {
        if (UpperCaseText(item.status) === FINANCE_OPTIONS.APPROVED) {
          isApproved = true;
        }
        if (
          index === paymentDesc.length - 1 &&
          (UpperCaseText(item.status) === FINANCE_OPTIONS.FINANCE_REFERRED ||
            UpperCaseText(item.status) === FINANCE_OPTIONS.CANCELLED)
        ) {
          isApproved = false;
        }
      });
    return isApproved;
  };

  render() {
    return (
      <div>
        {/*Notification for Order acceptance status*/}

        <OrderDetailsNotification
          user={this.props.user}
          showActionRequired={this.props.t(
            "CustomerOrderDetails.actionRequired"
          )}
          showMessage={this.props.t(
            "CustomerOrderDetails.messageNotOrderAccepted"
          )}
          warningColor={true}
          showCloseIcon={false}
          displayNotification={this.isCashNotAccepted(
            this.props.customerReservation
          )}
        />
        <OrderDetailsNotification
          user={this.props.user}
          showActionRequired={this.props.t(
            "CustomerOrderDetails.actionRequired"
          )}
          showMessage={this.props.t(
            "CustomerOrderDetails.messageNotFinanceApproved"
          )}
          warningColor={true}
          showCloseIcon={false}
          displayNotification={this.isFinanceNotAccepted(
            this.props.customerReservation
          )}
        />
        <OrderDetailsNotification
          user={this.props.user}
          showActionRequired={this.props.t(
            "CustomerOrderDetails.actionRequired"
          )}
          showMessage={this.props.t(
            "CustomerOrderDetails.messageNotLeaseApproved"
          )}
          warningColor={true}
          showCloseIcon={false}
          displayNotification={this.isLeaseNotAccepted(
            this.props.customerReservation
          )}
        />
        {/*Notification for Failed financial status*/}

        {!this.isOrderCancelled &&
          financeFailedStatuses.includes(this.getLatestFinanceStatus()) && (
            <OrderDetailsNotification
              user={this.props.user}
              showActionRequired={this.props.t(
                "CustomerOrderDetails.actionRequired"
              )}
              showMessage={this.props.t(
                "CustomerOrderDetails.customerNeedsSupport"
              )}
              showPriority={this.props.t("CustomerOrderDetails.mediumPriority")}
              warningColor={true}
              showCloseIcon={true}
              displayNotification={this.state.paymentNotification}
              handleClose={this.handlePaymentNotification}
            />
          )}
        {/*Notification for order updates triggered by FCE and ALD*/}
        {this.props.latestOrderUpdateNotifications &&
          this.props.latestOrderUpdateNotifications.map(
            (notification, index) => (
              <OrderDetailsNotification
                user={this.props.user}
                showActionRequired={this.props.t(
                  "CustomerOrderDetails.actionRequired"
                )}
                showMessage={this.getOrderUpdateNotificationMessage(
                  notification
                )}
                showPriority={false}
                warningColor={true}
                showCloseIcon={true}
                displayNotification={
                  this.state.closedNotifications.find(
                    (currentValue) => currentValue === index
                  ) === undefined
                }
                handleClose={() => this.handleOrderUpdateNotification(index)}
              />
            )
          )}

        {/*Notification for Trade In requested status*/}
        {!this.isReservation && this.props.tradeIn && (
          <OrderDetailsNotification
            user={this.props.user}
            showActionRequired={this.props.t(
              "CustomerOrderDetails.informationRequired"
            )}
            showMessage={this.props.t("CustomerOrderDetails.tradeInRequest")}
            warningColor={false}
            showCloseIcon={true}
            displayNotification={this.state.tradeInNotification}
            handleClose={this.handleTradeInNotification}
          />
        )}

        {/*Notification for Customer opt offline*/}
        {!this.isOrderCancelled &&
          this.props.customerReservation.offlineDocInfo &&
          this.props.customerReservation.offlineDocInfo.signStatus ===
            "SIGN_OFFLINE" &&
          !this.props.customerReservation.offlineDocInfo.dealerActionDate && (
            <OrderDetailsNotification
              user={this.props.user}
              showActionRequired={this.props.t(
                "CustomerOrderDetails.actionRequired"
              )}
              showMessage={this.props.t("CustomerOptOffline.wetSignRequired")}
              warningColor={true}
              displayNotification={this.state.optOfflineNotification}
              handleClose={this.handleOptOfflineNotification}
            />
          )}

        {/*Notification for Customer opt Undecided*/}
        {!this.isOrderCancelled &&
          this.props.customerReservation.offlineDocInfo &&
          this.props.customerReservation.offlineDocInfo.signStatus ===
            "SIGN_NOT_SELECTED" &&
          !this.props.customerReservation.offlineDocInfo.dealerActionDate && (
            <OrderDetailsNotification
              user={this.props.user}
              showActionRequired={this.props.t(
                "CustomerOrderDetails.actionRequired"
              )}
              showMessage={this.props.t("CustomerOptOffline.pendingSignStatus")}
              warningColor={true}
              displayNotification={this.state.optOfflineNotification}
              handleClose={this.handleOptOfflineNotification}
            />
          )}

        {/*Notification for inventory callout*/}
        {!this.props.customerReservation.hasInventory && (
          <OrderDetailsNotification
            user={this.props.user}
            showActionRequired={this.props.t(
              "CustomerOrderDetails.inventoryLessOrder"
            )}
            showMessage={this.props.t(
              "CustomerOrderDetails.inventoryLessOrderText"
            )}
            warningColor={true}
            showCloseIcon={false}
            displayNotification={this.state.inventoryLessNotification}
          />
        )}
      </div>
    );
  }
}

export default withTranslation("emp")(OrderDetailsActionNotifications);
